import React from 'react';
import PropTypes from 'prop-types';
import { CheckNearByStore } from './partials/store/CheckNearByStore';

export const PickupHeader = ({
  storeName,
  itemId,
  pickupUnavailable,
  isMajorAppliance,
  isCartTiles,
  localizerStoreName,
  addOnsAssemblyAndMore
}) => {
  const displayStoreName = isCartTiles ? (storeName || localizerStoreName) : storeName;
  const storeNameComponent = !isMajorAppliance || isCartTiles
    ? (
      <CheckNearByStore
        itemId={itemId}
        addOnsAssemblyAndMore={addOnsAssemblyAndMore}
      >
        {displayStoreName}
      </CheckNearByStore>
    )
    : displayStoreName;

  return (
    <div className="fulfillment__header">
      <span>
        {(pickupUnavailable || isMajorAppliance) ? <span className="u__bold">Unavailable </span> : <span>Pickup</span>}
        {(displayStoreName) && (
          <>
            {' at '}
            {storeNameComponent}
          </>
        )}
      </span>
    </div>
  );
};

PickupHeader.propTypes = {
  storeName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  pickupUnavailable: PropTypes.bool,
  isMajorAppliance: PropTypes.bool,
  isCartTiles: PropTypes.bool,
  localizerStoreName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: PropTypes.object
};

PickupHeader.defaultProps = {
  storeName: '',
  pickupUnavailable: false,
  isMajorAppliance: false,
  isCartTiles: false,
  localizerStoreName: '',
  addOnsAssemblyAndMore: null
};
